import {codeBlockType} from './CodeBlockSpecs';

export {codeBlockNodeName, CodeBlockNodeAttr as CodeBlockAttr} from './CodeBlockSpecs';
export const cbAction = 'toCodeBlock';
export {codeBlockType};
